export const checkPermission = (permission, userRole) => {
  const roles = userRole?.features?.map((item) => item.code);
  if (permission === '*') {
    return true;
  } else {
    return roles?.includes(permission);
  }
};
